<template>
	<div class="c-render-generation">
		<RenderConcept
			v-if="generation.type === 'CONCEPT' && generation.result"
			:script="generation.result"
		></RenderConcept>
		<RenderVideoScript
			v-if="generation.type === 'VIDEO' && generation.result"
			:script="generation.result"
		></RenderVideoScript>
		<RenderVideoToStoryboard
			v-if="generation.type === 'VIDEOTOSTORYBOARD' && generation.result"
			:script="generation.result"
		></RenderVideoToStoryboard>
		<RenderCopy
			v-if="generation.type === 'COPY' && generation.result"
			:script="generation.result"
		></RenderCopy>
		<Footer :generation="generation"></Footer>
	</div>
</template>

<script>
import RenderConcept from '@swipekit/components/utils/render-concept.vue';
import RenderVideoScript from '@swipekit/components/utils/render-video-script.vue';
import RenderVideoToStoryboard from '../utils/render-video-to-storyboard.vue';
import RenderCopy from '@swipekit/components/utils/render-copy';
import Footer from '@swipekit/components/generations/footer.vue';

export default {
	components: {
		RenderConcept,
		RenderVideoScript,
		RenderVideoToStoryboard,
		RenderCopy,
		Footer,
	},

	data: function () {
		return {};
	},

	props: {
		generation: {},
	},

	computed: {},

	methods: {},
};
</script>

<style lang="scss">
.c-render-generation {
}
</style>
